import * as d3 from 'd3';
import { Y_FIELD_MARK_LAYER_PREFIX } from '@/lib/data/chart';

import { canonicalizeLayerName } from '@/lib/data/vega';

export function render(el, story) {
  const $svg = d3.select(el).select('svg');
  const svgEl = $svg.node();

  // Creating this:
  // <defs>
  //   <filter id="line-glow-filter-${story.get('id')}">
  //     <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
  //     <feMerge>
  //       <feMergeNode in="blur"></feMergeNode>
  //       <feMergeNode in="SourceGraphic"></feMergeNode>
  //     </feMerge>
  //   </filter>
  // </defs>

  const feGaussianBlur = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'feGaussianBlur'
  );
  feGaussianBlur.setAttribute('result', 'blur');
  feGaussianBlur.setAttribute('stdDeviation', '3');

  const feMerge = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'feMerge'
  );

  const feMergeMergeNodeBlur = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'feMergeNode'
  );
  feMergeMergeNodeBlur.setAttribute('in', 'blur');
  const feMergeMergeNodeSourceGraphic = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'feMergeNode'
  );
  feMergeMergeNodeSourceGraphic.setAttribute('in', 'SourceGraphic');

  feMerge.appendChild(feMergeMergeNodeBlur);
  feMerge.appendChild(feMergeMergeNodeSourceGraphic);

  const lineGlowFilter = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'filter'
  );
  lineGlowFilter.setAttribute('id', `line-glow-filter-${story.get('id')}`);

  lineGlowFilter.appendChild(feGaussianBlur);
  lineGlowFilter.appendChild(feMerge);

  const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
  defs.appendChild(lineGlowFilter);

  svgEl.prepend(defs);

  const yAxisLineGroupEls = svgEl.querySelectorAll(
    `g[class*="${canonicalizeLayerName(Y_FIELD_MARK_LAYER_PREFIX)}"]`
  );

  yAxisLineGroupEls.forEach((yAxisLineGroupEl) => {
    const yAxisLinePathEl = yAxisLineGroupEl.querySelector('path');

    if (yAxisLinePathEl === null) {
      return;
    }

    const properties = JSON.parse(yAxisLinePathEl.getAttribute('aria-label'));

    if (!properties.glow) {
      return;
    }

    yAxisLineGroupEl.setAttribute(
      'filter',
      `url(#line-glow-filter-${story.get('id')})`
    );
  });
}
